module.exports = __webpack_public_path__ + "static/img/normal@3x.08ccf613.png";